import { configureStore, getDefaultMiddleware } from "@reduxjs/toolkit";
import { dealersReducer } from "./slices/dealerSlice";
import { dealersApi } from "./apis/dealerApi";
import { rdsesApi } from "./apis/rdseApi";


export const store=configureStore({
    reducer:{
        dealers:dealersReducer,
        [dealersApi.reducerPath]:dealersApi.reducer,
        [rdsesApi.reducerPath]:rdsesApi.reducer
    },
    middleware:(getDefaultMiddleware)=>{
        return getDefaultMiddleware()
        .concat(dealersApi.middleware)
        .concat(rdsesApi.middleware)
    }
})

export * from './thunks/addDealer';
export * from './thunks/fetchDealer';

export { useFetchDealersQuery,useUpdateDealerMutation } from './apis/dealerApi';
export { useFetchRdsesQuery } from './apis/rdseApi'